import { useTranslation } from "next-i18next";
import { sharedServerSideProps } from "@/src/utils/sharedServerSideProps";
import { ContentType } from "@/src/utils/enum";
import { Article } from "@/lib/types/Article";
import PageHead from "@/src/shared/PageHead";
import Header from "@/src/shared/Header/Header";
import MobileMenu from "@/src/shared/Header/subs/MainHeader/MobileMenu";
import Separator from "@/src/shared/Separator";
import Footer from "@/src/shared/Footer";
import BackToTop from "@/src/shared/BackToTop";
import ProgramsPage from "@/src/features/programs/ProgramsPage";
import ProgramsPageContext, { IProgramsPageContext } from "@/src/features/programs/ProgramsPageContext";
import API, { PagingResponse } from "@/lib/api";

export default function Index({ page }: { page: IProgramsPageContext }) {
  const { t } = useTranslation();

  return (
    <ProgramsPageContext.Provider value={page}>
      <PageHead title={t("programs")} />
      <Header />
      <MobileMenu />
      <ProgramsPage />
      <BackToTop />
      <Separator />
      <Footer />
    </ProgramsPageContext.Provider>
  );
}

export const getServerSideProps = sharedServerSideProps(async context => {
  const page = parseInt(context.query.page as string, 10) || 1;

  const response = await API.Client.get<PagingResponse<Article>>("/api/article/paging", {
    params: {
      Skip: 9 * (page - 1),
      Take: 9,
      WithCount: true,
      "Filters[ContentType]": ContentType.Programs
    }
  });

  return {
    page: {
      items: response.items,
      totalPages: Math.ceil(response.total / 9),
      totalCount: response.total,
      currentPage: page
    }
  };
});
